export default __webpack_public_path__ + "static/5-6ffe0c988efea8f1dc0381a48d638b42.jpg";